import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import Defines from '../../Defines';
import scrollIntoView from 'scroll-into-view';

/**
 * Import assets
 */
import star from "../../assets/img/icons/star.svg";
import policyIcon from '../../assets/img/icons/economy/beleidskeuze.png';
import budgetIcon from '../../assets/img/icons/globas_trimmed.png';
import {getMinistryARating, getMinistryColor, ministryOverfinanced} from '../../helpers/feedbackHelpers';

import { mapElements, mapColors } from '../../assets/assets';
import connect from "react-redux/es/connect/connect";

import config from '../../config';

let iconSize = false;
if (document.querySelector('#root').clientWidth > 750) { iconSize = 2; }

let flag = 0;
const widerMinistries = {
  nl: ['mc', 'hb', 'fb', 'lv'],
  en: ['mc', 'hb', 'fb', 'lv'],
};
const semiWideMinistries = {
  nl: ['kn'],
  en: ['vr', 'ws'],
};

class MapElement extends Component {
  static propTypes = {
    title: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    icon: PropTypes.string,
    value: PropTypes.number,
    feedbackCount: PropTypes.number,
    roundPoints: PropTypes.number,
    stars: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number
    ]),
    international: PropTypes.bool,
    target: PropTypes.string,
    budgetSet: PropTypes.any,
    policySet: PropTypes.any,
    disaster: PropTypes.any,
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  setImage = (min, value, difficulty) => {
    let type;
    if (difficulty === 'pro') {
      if (ministryOverfinanced(min, this.props.gameState)) type = 5;
      else type = getMinistryARating(difficulty, min, value, this.props.feedback.prevRoundFeedbackData) + 1;
      if (Defines.i18nMinistries.indexOf(min) !== -1 && type > 2) type -= 1;
    } else if (difficulty === 'basic') {
      const color = getMinistryColor(difficulty, min, this.props.gameState, this.props.gameStateInput, this.props.feedback.prevRoundFeedbackData);
      const internationalMinistry = Defines.i18nMinistries.indexOf(min) !== -1;
      if (internationalMinistry) {
        if (color === 'red') type = 1;
        if (color === 'orange' || color === 'lowOrange') type = 2;
        if (color === 'yellow' || color === 'lowYellow') type = 2;
        if (color === 'green') type = 3;
        if(ministryOverfinanced(min, this.props.gameState)) type = 4;
      } else {
        if (color === 'red') type = 1;
        if (color === 'orange' || color === 'lowOrange') type = 2;
        if (color === 'yellow' || color === 'lowYellow') type = 3;
        if (color === 'green') type = 4;
        if(ministryOverfinanced(min, this.props.gameState)) type = 5;
      }
    }
    return mapElements[`map_${min}__${min}${type}${iconSize !== false ? `${iconSize}x` : ''}`];
  };

  setPlateau = (min, value, difficulty) => {
    const color = getMinistryColor(difficulty, min, this.props.gameState, this.props.gameStateInput, this.props.feedback.prevRoundFeedbackData);

    return mapColors[difficulty + '_' + color];
  };

  getFeedBack = () => {
    let feedbackObject = [];
    if(!this.props.policySet && !this.props.budgetSet){
      if(this.props.feedbackCount > 0){
        feedbackObject.push(<div key="notCount" className="notification-count"><span><p>{this.props.feedbackCount}</p></span></div>);
      }
      return feedbackObject;
    }

    if(this.props.budgetSet){
      feedbackObject.push(<img key={1} src={budgetIcon} className={'budget-flag'} alt="Budget"/>);
    }

    if(this.props.policySet){
      feedbackObject.push(<img key={2} src={policyIcon} className={'policy-flag'} alt="Policy"/>);
    }

    return <div className="policyWrap">{feedbackObject}</div>;
  };

  isTouchDevice () {
    let isTouch = true;
    window.addEventListener('mousemove', function mouseMoveDetector() {
      isTouch = false;
      window.removeEventListener('mousemove', mouseMoveDetector);
    });

    return isTouch
  }

  goToClick = (e, target) => {
    e.preventDefault();
    if (!flag) {
      if (this.props.unHighlight === false) {
        target = '/'
      }
      //🤮🤮🤮
      sessionStorage.setItem('toMin', 'map');
      this.props.history.push(target);
    }

    flag = 0;
  };

  goToMouse = (e, target) => {
    e.preventDefault();

    e.target.addEventListener('mousemove', function(){
      flag = 1;
    });
    e.target.addEventListener('mouseup', () => {
      if (!flag) {
        if (this.props.unHighlight === false) {
          target = '/'
        }
        //🤮🤮🤮
        sessionStorage.setItem('toMin', 'map');
        this.props.history.push(target);
        if( !(this.props.unHighlight === false) ) {
          if(this.props.gameState.difficulty === "BASIC"){
            target = target.split('/').find(i => i.length === 2);
          }
          if(window.innerWidth < 1024) return;
          scrollIntoView(
            document.getElementById("scrollto-" + target.substr(-2)).closest(".desktop-ministry-list"),
            {
              topOffset: 200,
            }
          );
        }
      }
      flag = 0;
    });

    flag = 0;
  };

  render() {
    const {props} = this;
    const {schoolClass} = props;
    const lang = schoolClass.Language.code;

    let stars = [];
    for (var i = 0; i < this.props.stars; i++) {
      stars.push(<div className="inner" key={i}><img src={star} alt={"Star"}/></div>);
    }

    const groupBadge = (name, i) => {
      let matchedGroup = schoolClass.Groups.find(g => g.GroupTheme.color === name);
      if (matchedGroup) return <img key={i} className={'collab-inline-item-badge'} src={`${config.apiUrl}${matchedGroup.GroupTheme.badge}`} alt={'badge'} />;
    };

    return (
      <a onClick={(e) => this.goToClick(e, this.props.target)} onMouseDown={(e) => this.goToMouse(e, this.props.target)}
         className={this.props.unHighlight ? 'MapElement hide' : this.props.unHighlight === false ? 'MapElement show' : 'MapElement'} style={{
        top: this.props.top + "%",
        left: this.props.left + "%",
      }}>
        <div className={`content`}>
          <img src={ this.setImage(this.props.icon, this.props.value, this.props.difficulty) } alt={this.props.title}/>
          <img className={'plateau'} src={ this.setPlateau(this.props.icon, this.props.value, this.props.difficulty) } alt={'plateau'}/>

          <div className="overlay">
            <div className="content">
              {this.getFeedBack()}
              {props.feedback.currentRound > 1 && this.props.gameState.currentStep === 1 ?
                <div text={this.props.roundPoints} className="score">
                  {this.props.roundPoints}
                  <span text={__('sim_punten')}>{__('sim_punten')}</span>
                </div> :
                ''
              }
              {this.props.gameState.currentStep === 3 ? (
                <div text={this.props.globas} className="score">
                  {this.props.globas}
                  <span text={__('sim_miljard')}>{__('sim_miljard')}</span>
                </div>
              ) : ''}
            </div>
          </div>
          <div className="importance">
            {stars}

            {this.props.collaboration ?
              <div className={'collab-icons'}>
                {this.props.collaboration.map((group, i) => (
                  <span key={i}>
                  {groupBadge(group, i)}
                </span>
                ))}
              </div>
              : null }
          </div>
        </div>
        <div className={`
            name
            ${(semiWideMinistries[lang].includes(this.props.icon.toLowerCase()) ? "semiwide" : '')}
            ${(widerMinistries[lang].includes(this.props.icon.toLowerCase()) ? 'wide' : '')}
            ${(this.props.international ? 'international' :  '')} ${(!this.props.stars ? 'noStars' : '')}`
          }
         text={this.props.title}
        >
          {this.props.disaster ? <div className={`disasterHolder${this.props.gameState.language === "NL" ? "" : " en"}`}/> : null}
          {this.props.title}
        </div>
      </a>
    );
  }
}

export default connect(({schoolClass, feedback, gameState, gameStateInput}) => ({schoolClass, feedback, gameState, gameStateInput}))(MapElement);



// WEBPACK FOOTER //
// ./src/components/elements/MapElement.js